import { render, staticRenderFns } from "./PsConfigurationRates.vue?vue&type=template&id=6cae3ee6&scoped=true&"
import script from "./PsConfigurationRates.vue?vue&type=script&lang=js&"
export * from "./PsConfigurationRates.vue?vue&type=script&lang=js&"
import style0 from "./PsConfigurationRates.vue?vue&type=style&index=0&id=6cae3ee6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cae3ee6",
  null
  
)

export default component.exports